<template>
  <el-dialog title="选择用户" width="630px" :visible.sync="transferVisible">
  <el-transfer
    filterable
    :filter-method="filterMethod"
    v-model="value"
    :data="data">
  </el-transfer>
  <div slot="footer" class="dialog-footer">
      <el-button @click="transferVisible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="getval" size="mini">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'transfer',
    data() {
      return {
        transferVisible: false,
        data: [],
        value: [],
        filterMethod(query, item) {
          return item.val.indexOf(query) > -1;
        }
      };
    },
    methods: {
      getval() {
        this.transferVisible = false
        this.$emit('callback', this.value.join(','))
      }
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/transfer.vue